export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/sales_copy.b13a801.svg";